import { render, staticRenderFns } from "./FormConcentratorYeast.vue?vue&type=template&id=2bb501f1&scoped=true&"
import script from "./FormConcentratorYeast.vue?vue&type=script&lang=js&"
export * from "./FormConcentratorYeast.vue?vue&type=script&lang=js&"
import style0 from "./FormConcentratorYeast.vue?vue&type=style&index=0&id=2bb501f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb501f1",
  null
  
)

export default component.exports